import { useEffect } from 'react';
import { ApplicationState } from '@mews-commander/types';
import { ContentCard } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { Identifiable } from '@mews/std';
import { TextKey } from '@mews-commander/enums';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { getNumberOfProductServiceOrders } from '@mews-commander/legacy-entities/src/ducks';
import { fetchCurrentEnterpriseBillsByAccountIds } from '@mews-commander/legacy-entities/src/actions';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { BILL_DETAIL_EXTENT } from '../../../../billDetail/constants';
import { ServiceOrderTable } from './ServiceOrderTable';
import { BillsContainer } from './billsContainer';
import { CorrectionsContainer } from './correctionsContainer';

const DashboardTab = ({ id }: Identifiable) => {
    const dispatch = useCommanderThunkDispatch();
    const enterpriseId = useCurrentEnterpriseId();
    const numberOfServiceOrders = useCommanderSelector((state: ApplicationState) =>
        getNumberOfProductServiceOrders(state, { ownerId: id })
    );

    useEffect(() => {
        void dispatch(fetchCurrentEnterpriseBillsByAccountIds({ accountIds: [id], extent: BILL_DETAIL_EXTENT }));
    }, [dispatch, id]);

    return (
        <>
            <BillsContainer ownerId={id} enterpriseId={enterpriseId} />
            <ContentCard
                data-test-content-card="orders-table"
                title={<LocalizedText textKey={TextKey.ServiceOrderPlural} />}
                description={
                    <>
                        <LocalizedText textKey={TextKey.ServiceOrderPlural} />
                        {UnicodeEntity.Colon}
                        {UnicodeEntity.NoBreakSpace}
                        {numberOfServiceOrders}
                    </>
                }
            >
                <Stack vertical spacing="200">
                    <ServiceOrderTable id={id} />
                </Stack>
            </ContentCard>
            <CorrectionsContainer ownerId={id} enterpriseId={enterpriseId} />
        </>
    );
};

export default DashboardTab;
